import type { FieldPolicy } from '@apollo/client'

// User.permissions is a `@client` field populated by usePermissionResolution via cache.updateFragment.
// A subsequent User query (e.g. GetCurrentUser refetch) returns `permissions: []` and would wipe the
// populated array. This merge preserves existing when incoming is empty.
//
// We deliberately do NOT deep-merge non-empty arrays here: PermissionResolution has keyFields,
// so cached items are stored as refs ({__ref: ...}) with no `gate` property — any merge logic that
// keys on entity fields breaks against refs and corrupts the array on write.
// The updateFragment updater in usePermissionResolution already merges on dereferenced data before
// returning, so taking incoming verbatim here is correct.
const permissions: FieldPolicy<ResolvedPermissionResolution[]> = {
  merge(existing = [], incoming = []) {
    if (!incoming.length) return existing
    return incoming
  },
}

export default permissions
